import axios from 'axios';
import { FILE_API_URL_FILTER, URL_A } from '../../const/const';

interface FileData {
    deviceUID?: string;
    start?: string;
    end?: string;
    rating?: number[];
}
export const getFileDevicesFromDB = async (
    fileData: FileData,
    SmartDVRToken: string,
    userLogin: string,
    page: number,
    pageSize: number,
) => {
    if (!userLogin || !SmartDVRToken) {
        console.error('User information is missing.');
        return;
    }

    try {
        console.log('Token:', SmartDVRToken);
        console.log('Login:', userLogin);
        const response = await axios.post(FILE_API_URL_FILTER(page, pageSize), fileData, {
            headers: {
                SmartDVRLogin: userLogin,
                SmartDVRToken: SmartDVRToken,
            },
            timeout: 15000,
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching files from database:', error);
        throw error;
    }
};
